import { OneAddMembersDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import {
  OneCreateAction,
  OneCreationActionResolver,
} from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useAddMembersActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()

  const [addMembers, { loading }] = useMutation(OneAddMembersDocument, {
    extractorFn: (data) => data.postsMutations.addMembersPostsGroup,
    errorPolicy: 'all',
  })

  const addMembersHandler = async (args: { groupId: string; employeeIds: string[] }) => {
    const result = await addMembers({
      variables: {
        id: args.groupId,
        employeeIds: args.employeeIds,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success && handled.data.group?.id) {
      const url =
        handled.data.group.frontendUrl ??
        navigation.communities.id.fullPath({ id: handled.data.group.id })

      return {
        to: url,
        data: args,
      }
    }

    return handled
  }

  return {
    resolver: addMembersHandler,
    loading,
  }
}

export const AddMembersAction: OneCreateAction = {
  actionResolver: useAddMembersActionResolver,
  policies: [POSTS_POLICIES.postsManage],
}
